export const FETCH_CHECKOUT_INFO = 'FETCH_CHECKOUT_INFO';
export const UPDATE_BUYER = 'UPDATE_BUYER';
export const ADD_STUDENT = 'ADD_STUDENT';
